export default function(n, p) {
  return p ? Math.round(n * (p = Math.pow(10, p))) / p : Math.round(n);
}



//////////////////
// WEBPACK FOOTER
// /Users/darlacameron/projects/feature-federal-children-shelters-2018-06/node_modules/d3-jetpack/src/round.js
// module id = null
// module chunks = 